// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-mobile {
  height: calc(85% - 130px - 1rem);
  overflow: auto;
  width: 100%;
  padding: 1rem 1rem 0 1rem;
  margin-bottom: 0;
  list-style: none;
  flex-direction: column;
  display: none;
}
@media (max-width: 768px) {
  .sidebar-mobile {
    display: flex;
  }
}
.sidebar-mobile-container {
  top: 0;
  position: fixed;
  z-index: 999;
  width: 0;
  flex-direction: column;
  height: 100%;
  background: var(--black0);
  margin-left: 0;
  padding-top: 0;
  margin-bottom: 3rem;
  transition: all 0.15s ease;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  transform: translate3d(-280px, 0px, 0px);
  display: none;
  height: inherit;
}
@media (max-width: 768px) {
  .sidebar-mobile-container {
    display: flex;
  }
}
.sidebar-mobile-container .sidebar-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.sidebar-mobile-container .sidebar-container .sidebar {
  height: calc(100% - 3.75rem);
}
.sidebar-mobile-container .sidebar-container .sidebar-shops {
  padding-bottom: 0.75rem;
}
.sidebar-mobile-container.open {
  transform: translate3d(0, 0, 0);
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/layouts/dashboard/mobile-menu/index.scss"],"names":[],"mappings":"AAAA;EACE,gCAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;AACF;AACE;EAVF;IAWI,aAAA;EAEF;AACF;AAAE;EACE,MAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,cAAA;EACA,mBAAA;EACA,0BAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,uBAAA;EACA,wCAAA;EACA,aAAA;EACA,eAAA;AAEJ;AAAI;EArBF;IAsBI,aAAA;EAGJ;AACF;AADI;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AAGN;AADM;EACE,4BAAA;AAGR;AAAM;EACE,uBAAA;AAER;AAEI;EACE,+BAAA;EACA,WAAA;AAAN","sourcesContent":[".sidebar-mobile {\n  height: calc(85% - 130px - 1rem);\n  overflow: auto;\n  width: 100%;\n  padding: 1rem 1rem 0 1rem;\n  margin-bottom: 0;\n  list-style: none;\n  flex-direction: column;\n  display: none;\n\n  @media (max-width: 768px) {\n    display: flex;\n  }\n\n  &-container {\n    top: 0;\n    position: fixed;\n    z-index: 999;\n    width: 0;\n    flex-direction: column;\n    height: 100%;\n    background: var(--black0);\n    margin-left: 0;\n    padding-top: 0;\n    margin-bottom: 3rem;\n    transition: all .15s ease;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -webkit-user-drag: none;\n    transform: translate3d(-280px, 0px, 0px);\n    display: none;\n    height: inherit;\n\n    @media (max-width: 768px) {\n      display: flex;\n    }\n\n    .sidebar-container {\n      height: 100%;\n      display: flex;\n      flex-direction: column;\n\n      .sidebar {\n        height: calc(100% - 3.75rem);\n      }\n\n      .sidebar-shops {\n        padding-bottom: .75rem;\n      }\n    }\n\n    &.open {\n      transform: translate3d(0, 0, 0);\n      width: 100%;\n    }\n\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
